<template>
  <div>
    <!-- 搜索条件 -->
    <el-card>
      <el-input
        size="small"
        style="width: 180px; margin-right: 10px"
        placeholder="模糊查询"
        v-model="searchData"
        @input="searchInput"
        clearable
      ></el-input>
      <el-button type="primary" size="small" @click="getList(0)">搜索</el-button>
    </el-card>

    <!-- 需要选择的数据 -->
    <el-card style="margin-top: 5px; float: left; width: 47%">
      <el-table
        :data="filteredList(list)"
        style="width: 100%"
        border
        :height="height"
        highlight-current-row
        size="small"
      >
        <el-table-column :show-overflow-tooltip="true" align="center" width="50">
          <template slot-scope="scope">
            <i class="el-icon-circle-plus-outline" @click="addData(scope.row)" circle></i>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          :label="item.name"
          v-for="(item, index) in titleList"
          :key="index"
          :width="item.width ? item.width : undefined"
        >
          <template slot-scope="scope">
            <!-- 多规格显示数据 -->
            <span v-if="item.dataType == 'textList'">{{
              textListShow(scope.row[item.value])
            }}</span>
            <!-- 多图片显示数据 -->
            <el-image
              style="height: 30px"
              v-else-if="item.dataType == 'imageList' || item.dataType == 'imageListAll'"
              :src="imageListShow(scope.row[item.value])"
              :preview-src-list="[imageListShow(scope.row[item.value])]"
            >
            </el-image>
            <!-- 图片数据显示 -->
            <el-image
              style="height: 30px"
              v-else-if="item.dataType == 'image'"
              :src="url + scope.row[item.value]"
            >
            </el-image>
            <div v-else v-html="scope.row[item.value]"></div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="listQueryStatus != 1"
        :total="listQuery.total"
        :page-size="listQuery.pageSize"
        :current-page="listQuery.pageNum"
        @current-change="getList"
        style="margin-top: 20px"
      ></el-pagination>
    </el-card>
    <div
      :style="
        'text-align: center; float: left; margin: 5px 0; width: 6%; font-size: 40px;line-height:' +
        height +
        'px'
      "
    >
      <!-- <img src="@/assets/images/right.png" /> -->
      <span style="cursor: pointer" @click="allRight()">》</span>
    </div>
    <!-- 需要选中后的数据 -->
    <el-card style="margin-top: 5px; float: right; width: 47%">
      <el-table
        :data="selectList"
        style="width: 100%"
        border
        :height="height"
        highlight-current-row
        size="small"
      >
        <el-table-column :show-overflow-tooltip="true" align="center" width="50">
          <template slot-scope="scope">
            <i
              class="el-icon-remove-outline"
              @click="deleteData(scope.row, scope.$index)"
              circle
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          :label="item.name"
          v-for="(item, index) in titleList"
          :key="index"
          :width="item.width ? item.width : undefined"
        >
          <template slot-scope="scope">
            <!-- 多规格显示数据 -->
            <span v-if="item.dataType == 'textList'">{{
              textListShow(scope.row[item.value])
            }}</span>
            <!-- 多图片显示数据 -->
            <el-image
              style="height: 30px"
              v-else-if="item.dataType == 'imageList' || item.dataType == 'imageListAll'"
              :src="imageListShow(scope.row[item.value])"
              :preview-src-list="[imageListShow(scope.row[item.value])]"
            >
            </el-image>
            <!-- 图片数据显示 -->
            <el-image
              style="height: 30px"
              v-else-if="item.dataType == 'image'"
              :src="url + scope.row[item.value]"
            >
            </el-image>
            <div v-else v-html="scope.row[item.value]"></div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div style="clear: both"></div>
  </div>
</template>
<script>
export default {
  props: {
    // 选择框数据
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    // 分页参数
    listQuery: {
      type: Object,
      default: () => ({
        total: 0,
        pageNum: 1,
        pageSize: 10,
      }),
    },
    // 选择框数据
    titleList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 0.显示分页，1.不显示分页
    listQueryStatus: {
      type: Number,
      default: 0,
    },
    // table行高
    height: {
      type: Number,
      default: 200,
    },
    // 模糊搜索条件
    searchData: {
      type: String,
      default: "",
    },
    // 选中后数据
    selectList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    filteredList(list) {
      return this.list.filter((item) => !item.selected);
    },
    allRight() {
      this.selectList = [];
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].selected = true;
        this.selectList.push(this.list[i]);
      }
      this.$emit("syncSelectList", this.selectList);
    },
    searchInput() {
      this.$emit("searchInput", this.searchData);
    },
    getList(pageNum) {
      if (pageNum) {
        this.listQuery.pageNum = pageNum;
      }
      this.$emit("getList", this.searchData, this.listQuery);
    },
    addData(row) {
      row.selected = true;
      this.selectList.push(row);
    },
    deleteData(row, index) {
      row.selected = false;
      this.selectList.splice(index, 1);
    },
    // 多图片处理数据
    imageListShow(list) {
      let text = "";
      try {
        text = this.url + JSON.parse(list)[0].url;
      } catch (error) {}
      return text;
    },
    // 多规格数据处理显示
    textListShow(list) {
      let text = "";
      try {
        for (let i = 0; i < list.length; i++) {
          let kong = i == list.length - 1 ? "" : "/";
          text += list[i].specKey + ":" + list[i].specValue + kong;
        }
      } catch (error) {}
      return text;
    },
  },
};
</script>
